import { UsedHold } from "../assets/hangboards/classes/Hangboard";

export interface Workout{
    id:number
    type:string
    subtype:string
    date: string
    title: string
    subtitle: string
    author: string
    description: string
    img: string
    content: WorkoutContent
    tada:any
    hangboard: string
    intensityType: string
    time?: number
    desc?: string
    blocGroupContainer?: any
    getRepByIndex(index:number): Rep
}

export interface WorkoutContent{
    repNb: number
    duration: number
    difficulty: number
    hangboard: string
    type: string
    reps: Rep[]
}

export interface Rep{
    time: number
    intensity: number
    guideline: string
    fingers: [[], []]
    img?: string
    audio?: string
    grip?: number
    expectedStrength: number
    setIndex: number
    repIndex: number
    setCount: number
    repCount: number
    holds: UsedHold[]
}

export class Rep implements Rep{
    time: number = 0;
    intensity: number = 0;
    guideline: string = '';
    fingers: [[], []] = [[], []];
    expectedStrength: number = 0;
    setIndex: number = 0;
    repIndex: number = 0;
    setCount: number = 0;
    repCount: number = 0;
    holds: UsedHold[] = [];

    constructor(){
        this.time=0;
        this.intensity=0;
        this.guideline='';
        this.fingers =[[],[]];
        this.expectedStrength=0;
    }
}

export class Workout implements Workout{
    id: number = 0;
    type: string = '';
    subtype: string = '';
    date: string = '';
    title: string = '';
    subtitle: string = '';
    author: string = '';
    description: string = '';
    img: string = '';
    content: WorkoutContent = { repNb: 0, duration: 0, difficulty: 0, hangboard: '', type: '', reps: [] };
    tada: any = null;
    hangboard: string = '';
    intensityType: string = '';
    time?: number;
    desc?: string;
    blocGroupContainer?: any;

    constructor(props: Partial<Workout>){
        Object.assign(this, props);
        
        this.getRepByIndex = (index:number):Rep => {
            return this.content.reps[index];
        }
    }
}